
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-storage-solution",
      function () {
        return require("private-next-pages/college-storage-solution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-storage-solution"])
      });
    }
  